import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { useAppSelector } from "src/app-redux/hooks";
import { useStyles } from "./../style";
import NoRecordFound from "src/components/NoRecordFound";
import moment from "moment";
import { selectNodVehicleDetails } from "src/app-redux/vehicle/vehicleSlice";

export interface IDrawerHistoryProps {}

export default function DrawerHistory(props: IDrawerHistoryProps) {
  const classes = useStyles();
  // Redux
  const vehicleDetailsResponse: any = useAppSelector(selectNodVehicleDetails);
  return (
    <div className={classes.drawerDetails}>
      {/* History Item  */}
      {vehicleDetailsResponse.vehicleAudit?.length !== 0 ? (
        vehicleDetailsResponse.vehicleAudit?.map((item: any, index: any) => (
          <>
            <Typography className="headingHistory">
              {item.fieldName}{" "}
              {item.isDeleted && item.fieldName === " Vehicle"
                ? "has been marked In-valid by"
                : item.isDeleted
                ? " deleted by"
                : item.isPendingReview
                ? "moved to pending review by"
                : item.isRejected
                ? "rejected by"
                : "changed by"}{" "}
              {item.entryBy ? item.entryBy : "-"} :
            </Typography>
            <Grid key={index} container spacing={2} className="topContainer">
              <Grid container direction="row" className="itemRow">
                <Grid md={1}></Grid>
                <Grid md={6}>
                  <Typography className="subHeading">Vehicle Number</Typography>
                  <Typography className="subHeadingDetails">
                    {item.vehicleRegNumber ? item.vehicleRegNumber : "-"}
                  </Typography>
                </Grid>
                <Grid md={5}>
                  <Typography className="subHeading">Time & Date</Typography>
                  <Typography className="subHeadingDetails">
                    {moment(new Date(item.entryDate)).format("DD-MM-YYYY hh:mm A")}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container direction="row" className="itemRow">
                <Grid md={1}></Grid>
                <Grid md={6}>
                  <Typography className="subHeading">Previous Value</Typography>
                  <Typography className="subHeadingDetails">
                    {item.previousValue ? item.previousValue?.replace("@``@", "") : "-"}
                  </Typography>
                </Grid>
                <Grid md={5}>
                  <Typography className="subHeading">New Value</Typography>
                  <Typography className="subHeadingDetails">
                    {item.newValue ? item.newValue : "-"}
                  </Typography>
                </Grid>
                <Grid md={1}></Grid>
                {item.isPendingReview || item.isRejected || item.isDeleted ? (
                  <Grid md={10} style={{ marginTop: "10px" }}>
                    <Typography className="subHeading">Remarks</Typography>
                    <Typography className="subHeadingDetails">
                      {item.remarks ? item.remarks : "-"}
                    </Typography>
                  </Grid>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </>
        ))
      ) : (
        <div style={{ marginTop: "20px" }}>
          <NoRecordFound />
        </div>
      )}
    </div>
  );
}
